module.exports = __webpack_public_path__ + "img/dayout.42e280a3.svg";